import { PortalPopover } from "@/components/ui/PortalPopover";
import { HelpCircle } from "lucide-react";
import { useMemo } from "react";

import { CaseStatusHelpLegendView } from "../CaseStatusHelpLegendView";
import { buildCaseStatusLegendRows } from "./buildLegendRows";

export function StatusColumnHelp() {
  const rows = useMemo(() => buildCaseStatusLegendRows(), []);

  return (
    <PortalPopover
      variant="dense"
      title="Case statuses"
      panelClassName="w-80 max-w-[min(20rem,calc(100vw-1.5rem))]"
      panelHalfWidthPx={160}
      content={<CaseStatusHelpLegendView rows={rows} />}
    >
      <HelpCircle className="h-4 w-4 shrink-0 cursor-help" aria-label="Status descriptions" />
    </PortalPopover>
  );
}
